import {
  Box,
  Tab,
  TabIndicator,
  TabList,
  TabPanel,
  TabPanels,
  Tabs
} from '@chakra-ui/react';
import React, { ReactElement, useState } from 'react';
import { PageTitle } from '@app/components/PageTitle';
import Metadata from '@app/components/Metadata';
import AnimatedLayout from '@app/layouts/AnimatedLayout/AnimatedLayout';
import SpNftMarketPlaceList from '@app/screens/nft-marketplace/SpNftMarketPlaceList/SpNftMarketPlaceList';
import { MarketplaceRequirements } from '@app/screens/nft-marketplace/MarketplaceRequirements';
import s from '@app/pages/pools/v2/[id]/PairDetailsPage.module.scss';
import { NftCartContext } from '@app/context/NftCartContext';
import { useToggle } from 'react-use';
import { CheckoutModal } from '@app/screens/nft-marketplace/Cart/CheckoutModal';
import { MyPositionsNftMarketplaceView } from '@app/screens/positions/components/SpNftsList/MyPositionsNftMarketplaceView';
import { RewardNfts } from '@app/screens/nft-marketplace/RewardNfts';

export const NftMarketplacePage = () => {
  const [isOpen, toggleModal] = useToggle(false);
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabsChange = (index: number) => {
    setTabIndex(index);
  };

  return (
    <NftCartContext.Provider value={{ isOpen, toggleModal }}>
      <Box width="100%" mt={8} px={[0, 0]}>
        <PageTitle
          title="NFT Marketplace"
          subtitle="Trade your LP positions, NFTs and more!"
          bg="/assets/images/bg/img.png"
        >
          <MarketplaceRequirements />
        </PageTitle>

        <Box mt={8}>
          <Tabs index={tabIndex} onChange={handleTabsChange}>
            <TabList className={s.tabs}>
              <Tab className={s.tab}>kpNFTs</Tab>
              <Tab className={s.tab}>Rewards NFTs</Tab>
              <Tab className={s.tab}>My Positions</Tab>
            </TabList>
            <TabIndicator
              mt="-3px"
              height="3px"
              bg="orange"
              borderRadius="1px"
            />
            <TabPanels className={s.tabsPanels}>
              <TabPanel>{tabIndex === 0 && <SpNftMarketPlaceList />}</TabPanel>
              <TabPanel>{tabIndex === 1 && <RewardNfts />}</TabPanel>
              <TabPanel>
                {tabIndex === 2 && <MyPositionsNftMarketplaceView />}
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Box>
      </Box>
      <CheckoutModal isOpen={isOpen} />
    </NftCartContext.Provider>
  );
};

NftMarketplacePage.getLayout = function getLayout(page: ReactElement) {
  return (
    <AnimatedLayout>
      <Metadata
        title="NFT Marketplace"
        description="Buy, sell, and auction kpNFTs"
      />
      {page}
    </AnimatedLayout>
  );
};

export default NftMarketplacePage;
